export const externalShareBaseUrl = "/api/external_sharing"

export const externalShareComponentUrl = "/call_sharing"
